import React from 'react'
import Budgets from 'src/app/Budgets/Budgets'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import BudgetHistoryAppRoute from 'src/navigation/appRoutes/budget/budgetHistory.appRoute'
import BudgetOverviewAppRoute from 'src/navigation/appRoutes/budget/budgetOverview.appRoute'
import BudgetTransactionsAppRoute from 'src/navigation/appRoutes/budget/budgetTransactions.appRoute'
import BudgetVirtualCardsAppRoute from 'src/navigation/appRoutes/budget/budgetVirtualCards.appRoute'
import BudgetsAllBudgetsAppRoute from 'src/navigation/appRoutes/budgets/budgetsAllBudgets.appRoute'
import BudgetsNeedsApprovalAppRoute from 'src/navigation/appRoutes/budgets/budgetsNeedsApproval.appRoute'
import { budgetsRouteProps } from 'src/navigation/routeProps'

const BudgetsAppRoute: AppRoute = {
  id: AppLocation.BudgetDetail,
  routeProps: budgetsRouteProps,
  component: <Budgets />,
  subRoutes: [
    BudgetsAllBudgetsAppRoute,
    BudgetsNeedsApprovalAppRoute,
    BudgetOverviewAppRoute,
    BudgetVirtualCardsAppRoute,
    BudgetTransactionsAppRoute,
    BudgetHistoryAppRoute,
  ],
  exceptions: [
    BudgetOverviewAppRoute,
    BudgetVirtualCardsAppRoute,
    BudgetTransactionsAppRoute,
    BudgetHistoryAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetsAppRoute
